import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getTokenExpiration } from "Common/Components/getRoleId";

interface AuthProtectedProps {
  children: ReactNode;
}

const TOKEN_MAX_AGE_MS = 55 * 60 * 1000;

const clearAuth = () => {
  localStorage.removeItem("app_havir");
  localStorage.removeItem("app_rt");
  localStorage.removeItem("login_time");
};

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const location = useLocation();

  const accessToken = localStorage.getItem("app_havir");
  const refreshToken = localStorage.getItem("app_rt");
  const loginTimeStr = localStorage.getItem("login_time");

  if (!accessToken || !refreshToken || !loginTimeStr) {
    clearAuth();
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const tokenExpiration = getTokenExpiration(accessToken);

  if (!tokenExpiration || tokenExpiration.getTime() <= Date.now()) {
    clearAuth();
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const loginTime = Number(loginTimeStr);

  if (!Number.isFinite(loginTime)) {
    clearAuth();
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (Date.now() - loginTime > TOKEN_MAX_AGE_MS) {
    clearAuth();
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default AuthProtected;